// Montos de comprobantes electrónicos: SIEMPRE con 2 decimales (son documentos
// legales con céntimos exactos), formato es-CR: miles ".", decimal ",".
// A diferencia de formatMoney de costos (que omite ",00"), acá el céntimo
// importa — el usuario coteja contra el PDF de la factura.
//
// Formateo manual (no Intl.NumberFormat) por la misma razón que
// cost-allocations/utils/formatMoney.ts: "es-CR" varía entre versiones de Node.

const CURRENCY_SYMBOL: Record<string, string> = {
  CRC: "₡",
  USD: "$",
};

function groupThousands(intStr: string): string {
  return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatInvoiceAmount(
  cents: number | null | undefined,
  currency: string | null,
): string {
  if (cents === null || cents === undefined || !Number.isFinite(cents)) return "—";
  if (cents < 0) return "—";

  const intPart = Math.floor(cents / 100);
  const fracCents = cents % 100;
  const symbol = CURRENCY_SYMBOL[currency ?? "CRC"] ?? `${currency} `;
  return `${symbol}${groupThousands(String(intPart))},${String(fracCents).padStart(2, "0")}`;
}

// Tipo de cambio del XML (numeric → string "512.34000") → "₡512,34".
export function formatExchangeRate(rate: string | null): string {
  if (rate === null) return "—";
  const num = Number(rate);
  if (!Number.isFinite(num) || num <= 0) return "—";
  return formatInvoiceAmount(Math.round(num * 100), "CRC");
}
